<template>
  <template v-if="mode === 'interno'">
    <div v-if="isVideo">
      <video controls autoplay muted loop style="max-height:700px; width: 100%;">
        <source :src="pregunta.imagen" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <v-img v-else max-height="700" :src="pregunta.imagen" />
    <v-card variant="text">
      <v-card-title class="text-wrap" style="word-break: break-word">
        {{ pregunta.texto }}
      </v-card-title>
    </v-card>
    <v-btn block color="primary" class="mt-3" @click="next">
      {{ t('Continua') }}
    </v-btn>
  </template>
  <template v-if="mode === 'externo'">De moment no hi ha més preguntes.</template>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const props = defineProps({
  pregunta: {
    type: Object,
    default: () => ({}),
  },
  mode: {
    type: String,
    default: 'interno',
    // 'interno'  => El componente hace el axios POST a enviar_respuestas/.
    // 'externo'  => El componente emite el evento con los datos, 
    //               y NO hace la petición dentro.
  },
});

const emit = defineEmits(['respuesta-enviada']);
const { t } = useI18n();

// Check if the file is a video (mp4)
const isVideo = computed(() => {
  if (props.pregunta && props.pregunta.imagen) {
    try {
      const urlObj = new URL(props.pregunta.imagen);
      return urlObj.pathname.toLowerCase().endsWith('.mp4');
    } catch (e) {
      // Fallback if URL parsing fails
      return props.pregunta.imagen.toLowerCase().includes('.mp4');
    }
  }
  return false;
});


function next() {
  // Emitir el evento que indica que la pregunta ha sido contestada y pasamos a la siguiente.
  emit('respuesta-enviada', props.pregunta);
}
</script>